export default __webpack_public_path__ + "static/footer-49f0be20c35cdafefd1b4db7ce0927e3.png";